const featureNames = {
  INSIGHTS: "INSIGHTS",
  PIP: "PIP",
  MEDIA: "MEDIA",
};

export default featureNames;
